import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/onboarding-v2")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
